module.exports = __webpack_public_path__ + "static/media/taiwan_02.a82149ae.png";